function formatNumber(value: number) {
	value = value * 1;

    if (value === undefined || value === null || isNaN(value)) {
        return 'Not yet available';
    }
    
	const absValue = Math.abs(value);

	if (absValue < 1_000) {
		return value.toFixed(0);
	}
	let num, nominator;
	if (absValue < 1_000_000) {
		num = value / 1_000;
		nominator = 'k';
	} else if (absValue < 1_000_000_000) {
		num = value / 1_000_000;
		nominator = 'm';
	} else {
		num = value / 1_000_000_000;
		nominator = 'b';
	}
	return `${num.toFixed(1)}${nominator}`.replace(/\.0/, '');
}

export default formatNumber;


export function formatFullNumber(number: number): any {
	if (Number(number) < 1000) {
		return '' + number;
	}
	return formatFullNumber(Math.floor(number / 1000)) + '.' + ('' + (Number(number) % 1000)).padStart(3, '0');
}

export function localeNumber(number: number): string {
	return number.toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
}
